import { render } from "./AdmSchedule.vue?vue&type=template&id=61606947&scoped=true"
import script from "./AdmSchedule.vue?vue&type=script&lang=js"
export * from "./AdmSchedule.vue?vue&type=script&lang=js"

import "./AdmSchedule.vue?vue&type=style&index=0&id=61606947&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61606947"]])

export default __exports__